import { X } from 'lucide-react';

export function LeadBatchActionBar({ selectedCount, stages, team, batchStage, batchAssign, clearSelection }) {
  if (selectedCount <= 0) return null;
  return (
    <div className="flex items-center gap-3 rounded-sm border border-zinc-950 bg-zinc-950 p-3 text-white animate-fade-in" data-testid="batch-action-bar">
      <span className="text-sm font-semibold">{selectedCount} selected</span>
      <div className="flex gap-1.5 flex-1 flex-wrap">
        {stages.map((stage) => <button key={stage} onClick={() => batchStage(stage)} className="px-2.5 py-1 rounded text-xs font-medium bg-zinc-800 hover:bg-zinc-700 transition-colors capitalize" data-testid={`batch-stage-${stage}`}>{stage}</button>)}
        <select onChange={(event) => { if (event.target.value) batchAssign(event.target.value); event.target.value = ''; }} className="h-7 rounded bg-zinc-800 text-white text-xs px-2 border-zinc-700" data-testid="batch-assign-select">
          <option value="">Assign to...</option><option value="">Unassign</option>{team.map((member) => <option key={member.id} value={member.id}>{member.name}</option>)}
        </select>
      </div>
      <button onClick={clearSelection} className="text-zinc-400 hover:text-white" data-testid="batch-clear"><X className="w-4 h-4" /></button>
    </div>
  );
}